import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import MainLayout from './components/Layout/MainLayout';
import LoginPage from './pages/Login/LoginPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import TimeTrackingPage from './pages/TimeTracking/TimeTrackingPage';
import HandbookPage from './pages/Handbook/HandbookPage';
import EventsPage from './pages/Events/EventsPage';
import NewEventPage from './pages/Events/NewEventPage';
import EventDetailsPage from './pages/Events/EventDetailsPage';
import OAuth2Callback from './pages/OAuth/OAuth2Callback';
import LoadingSpinner from './components/Common/LoadingSpinner';
import EmployeesPage from './pages/Employees/EmployeesPage';
import EquipmentPage from './pages/Equipment/EquipmentPage';
import { RoleProvider } from './context/RoleContext';
// Protected route component that checks authentication
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner text="Loading..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <RoleProvider>
        <Router>
          <Routes>
            {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/oauth2callback" element={<OAuth2Callback />} />
          
          {/* Default route for root path - redirects to dashboard if authenticated or login if not */}
          <Route 
            path="/" 
            element={
              <AuthRedirect />
            }
          />
          
          {/* Protected routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <MainLayout>
                  <DashboardPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/time-tracking" 
            element={
              <ProtectedRoute>
                <MainLayout>
                  <TimeTrackingPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/employees" 
            element={
              <ProtectedRoute>
                <MainLayout>
                  <EmployeesPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/equipment" 
            element={
              <ProtectedRoute>
                <MainLayout>
                  <EquipmentPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/handbook" 
            element={
              <ProtectedRoute>
                <MainLayout>
                  <HandbookPage />
                </MainLayout>
              </ProtectedRoute>
            }
          />

          <Route path="/events" element={<ProtectedRoute>
            <MainLayout>
              <EventsPage />
            </MainLayout>
          </ProtectedRoute>} />
          
          {/* Event Routes */}
          <Route path="/events/new" element={<ProtectedRoute>
            <MainLayout>
              <NewEventPage />
            </MainLayout>
          </ProtectedRoute>} />
          
          <Route path="/events/:eventId" element={<ProtectedRoute>
            <MainLayout>
              <EventDetailsPage />
            </MainLayout>
          </ProtectedRoute>} />
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Router>
      </RoleProvider>
    </AuthProvider>
  );
}

// Component to redirect based on authentication status
const AuthRedirect = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <LoadingSpinner text="Loading..." />;
  }
  
  return user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
};

export default App;
